export default __webpack_public_path__ + "static/media/invite_page.7841881e.jpg";